"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _UnknownTooltip = _interopRequireDefault(require("./UnknownTooltip"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function VoucherRedeem(row) {
  var sourceEntity = (0, _get2["default"])(row, 'sourceEntity');
  var targetEntity = (0, _get2["default"])(row, 'targetEntity');
  if (targetEntity && sourceEntity) {
    return /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("b", null, targetEntity), " created new license using voucher ", /*#__PURE__*/_react["default"].createElement("b", null, sourceEntity));
  }
  if (targetEntity) {
    return /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("b", null, targetEntity), " created new license using a voucher that has since been deleted");
  }
  if (sourceEntity) {
    return /*#__PURE__*/_react["default"].createElement("span", null, "An unknown user created new license using a voucher ", /*#__PURE__*/_react["default"].createElement("b", null, sourceEntity), /*#__PURE__*/_react["default"].createElement(_UnknownTooltip["default"], null));
  }
  return /*#__PURE__*/_react["default"].createElement("span", null, "An unknown user created new license using a voucher that has since been deleted", /*#__PURE__*/_react["default"].createElement(_UnknownTooltip["default"], null));
}
var _default = exports["default"] = VoucherRedeem;